import { render, staticRenderFns } from "./SearchAddress.vue?vue&type=template&id=137e7b3a&"
import script from "./SearchAddress.vue?vue&type=script&lang=js&"
export * from "./SearchAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports